import {SHIELD_CONTRACT} from  "../../constants/contracts";

export const web3GetNextClaimDate = async (address: string, chainId: number, web3: any) => {
    const shieldContract = SHIELD_CONTRACT[chainId];
    const contract = new web3.eth.Contract(shieldContract.abi, shieldContract.address);
    const date = await contract.methods.nextAvailableClaimDate(address).call();
    return new Date(date * 1000);
}
